import { useEffect, useState } from 'react';
import SeoHead from '../components/Seo/SeoHead';

const PRIVATE_ROUTE_PREFIXES = [
  '/login',
  '/register',
  '/tableau-de-bord',
  '/messagerie',
  '/mes-brouillons',
  '/profil',
  '/characters/new',
  '/characters/npc',
  '/mes-factions',
  '/factions/new',
  '/components',
  '/test',
  '/rp-activities/new',
];

const PRIVATE_EXACT_ROUTES = [
  '/characters',
];

export const isPrivateRoute = (pathname) => {
  if (!pathname) return false;
  if (PRIVATE_EXACT_ROUTES.includes(pathname)) return true;
  if (/^\/characters\/\d+\/edit$/.test(pathname)) return true;
  if (/^\/characters\/npc\//.test(pathname)) return true;
  if (/^\/factions\/\d+\/edit$/.test(pathname)) return true;
  return PRIVATE_ROUTE_PREFIXES.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`));
};

export const useSeoLoader = (loader, deps = []) => {
  const [seo, setSeo] = useState(null);

  useEffect(() => {
    let mounted = true;

    const load = async () => {
      try {
        const data = await loader();
        if (mounted) {
          setSeo(data || null);
        }
      } catch (error) {
        if (mounted) {
          setSeo(null);
        }
      }
    };

    load();

    return () => {
      mounted = false;
    };
  }, deps);

  return seo;
};

export const useRouteSeoGuard = (pathname) => {
  const noindexSeo = {
    metaTitle: 'Earth Forum',
    metaDescription: '',
    robotsIndex: false,
  };

  if (isPrivateRoute(pathname)) {
    return noindexSeo;
  }

  return null;
};

export { SeoHead };
